import React from 'react';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MegaMenu } from 'components/mega-menu/megaMenu';
import { BreadcrumbTooltip } from 'components/tooltips/BreadcrumbTooltip';
import { clearBatchDefinition } from 'ducks/batch-definition/slices';
import { useAppDispatch, useAppSelector } from 'ducks/hooks';
import { setModal } from 'ducks/modals/slices';
import { selectProject } from 'ducks/project/selectors';
import { selectProjects } from 'ducks/projects/selectors';

import cn from 'components/breadcrumbs/Breadcrumbs.module.scss';

export const ScheduledBatches = () => {
  const dispatch = useAppDispatch();

  const project = useAppSelector(selectProject);
  const projects = useAppSelector(selectProjects);

  const handleManageScheduleBatch = () => {
    dispatch(clearBatchDefinition());
    dispatch(setModal({ manage_schedule_batch: true }));
  };

  const project_name = `${project.project_name ?? 'Projects'}`;
  return (
    <>
      <div className={cn.items}>
        <MegaMenu labels={project_name} values={projects} page="scheduled_batches" />
        <FontAwesomeIcon className={cn.breadcrumbIcon} icon={faChevronRight} />
        <div className={cn.breadcrumb}>Scheduled Batches</div>
        <div className={cn.flexGrow} />
      </div>
      <div className={cn.circle} onClick={handleManageScheduleBatch}>
        <BreadcrumbTooltip tooltip="Create Scheduled Batch" />
      </div>
    </>
  );
};
